import React, { useEffect, useState } from "react";
import RaceTabs from "./RaceTabs";
import WagerTypesConstants from "../../constants/WagerTypesConstants";
import ErrorCodes from "../../constants/ErrorCodes";
import { useSelectFunctions } from "../../functions";

const Container = ({
  trackInfo,
  raceID,
  selectOption,
  userInfo,
  stateTracks,
  setStateTracks,
  tracksDate,
  race,
  setRaceInfo,
  racesTracks,
  setRefreshInfo,
  refreshInfo,
  setRefreshEntries,
  refreshEntries,
  entries,
  setEntries,
  resultsList,
  setResultsList,
  sessionNoLongerExists,
  setSessionNoLongerExists,
  readOnlyResults,
  setReadOnlyResults,
  voidTickets,
  callTicketVoidListFrom,
  selectedTicketsVoidScore,
  setSelectedTicketsVoidScore,
  selectAllTickets,
  setSelectAllTickets,
  scoreTickets,
  setCallTicketVoidListFrom,
  setSelectedTicketsVoidScoreContainer,
  selectedTicketsVoidScoreContainer,
  callPastPostMethod,
  setCallPastPostMethod,
}) => {
  const [charts, setCharts] = useState([]);
  const [activeChartTab, setActiveChartTab] = useState("Win");
  const [insertOrViewResults, setInsertOrViewResults] = useState(false);
  const { getEntries, getChartsList, getResultsList } = useSelectFunctions();

  //DATE
  let month, date;
  month = tracksDate
    .toLocaleString("default", { month: "short" })
    .toUpperCase();
  date = tracksDate.getDate();

  // This hook executes the GetEntries method with the necessary information to fill the Entries table.
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await getEntries(
          {
            RaceID: raceID,
          },
          userInfo.LogonSessionID,
        );

        if (!res.error) {
          setEntries(res.EntryList);
        }

        WagerTypesConstants.forEach((item) => {
          if (item.name === activeChartTab) {
            getCharts(item.id);
          }
        });
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, [refreshEntries, activeChartTab]);

  // This function executes the GetCharts method with the necessary information to fill the Chart tab.
  const getCharts = async (betType) => {
    const res = await getChartsList(
      {
        RaceID: selectOption.raceID,
        BetType: betType,
      },
      userInfo.LogonSessionID,
    );

    if (res?.error) {
      if (
        res.Result === ErrorCodes.InvalidSession ||
        res.Result === ErrorCodes.SessionNoLongerExists
      ) {
        setSessionNoLongerExists(true);
      }
      return;
    } else {
      setCharts(res.Charts);
    }
  };

  //GET RESULTS
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await getResultsList(
          {
            RaceID: selectOption.raceID,
          },
          userInfo.LogonSessionID,
        );

        if (res?.error) {
          if (
            res.Result === ErrorCodes.InvalidSession ||
            res.Result === ErrorCodes.SessionNoLongerExists
          ) {
            setSessionNoLongerExists(true);
          }
          return;
        } else {
          if (res.WPSList && res.WPSList.length === 0 && insertOrViewResults) {
            res.WPSList = [
              {
                Pos: 1,
                Entryname: "",
                Entrynum: "",
                Win: "",
                Place: "",
                Show: "",
              },
              {
                Pos: 2,
                Entryname: "",
                Entrynum: "",
                Win: "",
                Place: "",
                Show: "",
              },
              {
                Pos: 3,
                Entryname: "",
                Entrynum: "",
                Win: "",
                Place: "",
                Show: "",
              },
            ];
          }
          setResultsList(res);
          setReadOnlyResults(res);
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, [selectOption, insertOrViewResults]);

  return (
    <>
      {trackInfo && (
        <div>
          <div
            style={{
              color: "#808080",
              textAlign: "center",
            }}
          >
            <label
              className="ml-3 lead"
              style={{
                fontSize: "20px",
                margin: "0px",
              }}
            >
              {month} - {date}
            </label>
            <label
              className="ml-2"
              style={{
                borderRight: "1px solid #bfbfbf",
                fontSize: "25px",
                color: "transparent",
              }}
            >
              .
            </label>
            <label
              className="ml-2 lead"
              style={{
                fontSize: "20px",
                margin: "0px",
                fontWeight: "bold",
              }}
            >
              <span style={{ color: "#17a2b8", fontWeight: "bold" }}>
                {trackInfo.TrackCode}
              </span>{" "}
              {trackInfo.TrackName}
            </label>
            <label
              className="ml-2"
              style={{
                borderRight: "1px solid #bfbfbf",
                fontSize: "25px",
                color: "transparent",
              }}
            >
              .
            </label>
            <label
              className="ml-2 lead"
              style={{
                fontSize: "18px",
                margin: "0px",
                fontWeight: "bold",
              }}
            >
              RACE {selectOption.raceNumber}
            </label>
          </div>
          {racesTracks && race.RaceID !== 0 && (
            <RaceTabs
              entries={entries}
              setEntries={setEntries}
              RaceID={raceID}
              userInfo={userInfo}
              raceInfo={race}
              setRaceInfo={setRaceInfo}
              stateTracks={stateTracks}
              setStateTracks={setStateTracks}
              trackID={selectOption.trackID}
              resultsList={resultsList}
              setResultsList={setResultsList}
              getCharts={getCharts}
              charts={charts}
              selectOption={selectOption}
              trackCode={trackInfo.TrackCode}
              racesTracks={racesTracks}
              setRefreshInfo={setRefreshInfo}
              refreshInfo={refreshInfo}
              setRefreshEntries={setRefreshEntries}
              refreshEntries={refreshEntries}
              activeChartTab={activeChartTab}
              setActiveChartTab={setActiveChartTab}
              sessionNoLongerExists={sessionNoLongerExists}
              setSessionNoLongerExists={setSessionNoLongerExists}
              readOnlyResults={readOnlyResults}
              insertOrViewResults={insertOrViewResults}
              setInsertOrViewResults={setInsertOrViewResults}
              voidTickets={voidTickets}
              callTicketVoidListFrom={callTicketVoidListFrom}
              selectedTicketsVoidScore={selectedTicketsVoidScore}
              setSelectedTicketsVoidScore={setSelectedTicketsVoidScore}
              selectAllTickets={selectAllTickets}
              setSelectAllTickets={setSelectAllTickets}
              scoreTickets={scoreTickets}
              setCallTicketVoidListFrom={setCallTicketVoidListFrom}
              setSelectedTicketsVoidScoreContainer={
                setSelectedTicketsVoidScoreContainer
              }
              selectedTicketsVoidScoreContainer={
                selectedTicketsVoidScoreContainer
              }
              callPastPostMethod={callPastPostMethod}
              setCallPastPostMethod={setCallPastPostMethod}
            />
          )}
        </div>
      )}
    </>
  );
};

export default Container;
